import type { CurrentUser } from '../types/user';

// Team values are not a managed list (Slice B §5.3 / Q5): the set of teams
// is whatever distinct non-null User.team values exist across users. AMs
// don't create teams from task / template forms — an admin sets User.team
// (Firestore Console for now). This pure helper derives the deduplicated,
// alphabetically-sorted team list shared by the task assignment picker
// (§5.2) and the template item form's default-team dropdown (§3.6).
export function distinctTeams(users: CurrentUser[]): string[] {
  const seen = new Set<string>();
  for (const u of users) {
    const t = u.team?.trim();
    if (t) seen.add(t);
  }
  return [...seen].sort((a, b) => a.localeCompare(b));
}

// The assignment picker's team options are the distinct User.team values
// PLUS the task's currently-assigned team if it isn't among them. A team
// applied from a template's defaultTeam (Slice B §5.5) may not match any
// current User.team — without merging it in, the picker would render the
// option missing and the select would visually fall back to "Unassigned"
// even though assignedTeam is set. Keeps the applied-team selectable +
// visible. Pure + sorted; deduped.
export function mergeTeamOptions(
  teams: string[],
  current: string | null,
): string[] {
  const set = new Set(teams);
  const c = current?.trim();
  if (c) set.add(c);
  return [...set].sort((a, b) => a.localeCompare(b));
}
